import React from 'react';
import styles from './ReviewStats.module.scss';
import { ReactComponent as ReviewIcon } from '../../images/icons/review.svg';
import Rating from '../Rating/Rating';
import classNames from 'classnames';

const ReviewStats = ({ classList, ratingValue, reviewsCount }) => {
  return (
    <div className={classNames(classList?.root || styles.root, classList?.rootComplementary)}>
      <Rating value={ratingValue || 0} />
      <span className={classList?.reviewsCount || styles.reviewsCount}>
        <ReviewIcon /> {reviewsCount || 0}
      </span>
    </div>
  );
};

export default ReviewStats;
